const QueryKey = {
    poTrackingList: 'poTrackingList',
    comUserProfile: 'comUserProfile',
    comList: 'comList',
    potList: 'potList',
    amctSinglePo: 'amctSinglePo',
    singleCom: 'singleCom',
    amctSinglePoProd: 'amctSinglePoProd',

}

export default QueryKey;